// Browser-side client for the slice-D /api/admin/action?action=ai-prompts-dry-run
// endpoint. Split out of the main `client.ts` to keep that file under the
// file-size soft limit once the dry-run flow + result DTOs landed.

import { call, DRY_RUN_ACTION } from "./clientRequest";

export { DRY_RUN_ACTION };

export type DryRunFixtureDTO = {
  label: string;
  description: string;
  transcript: string;
  expected_field_count: number;
};

export type DryRunSuccessDTO = {
  ok: true;
  fixture: DryRunFixtureDTO;
  parsed: Record<string, unknown>;
  populated_count: number;
  duration_ms: number;
};

export type DryRunFailureDTO = {
  ok: false;
  error: string;
  // 'validation' = caller's draft is structurally invalid; surface inline.
  // 'parse_failed' / 'upstream' / 'server' = the dry-run completed but
  // the model's response was unusable; UI shows as a "Test failed" state.
  // 'no_fixture' = catalog entry has no registered fixture (button
  // shouldn't have been shown — defensive).
  reason: "validation" | "parse_failed" | "upstream" | "server" | "no_fixture";
  raw?: string;
};

/**
 * Calls the dry-run endpoint. Unlike most other client helpers, the
 * server here returns its own `{ ok, ... }` envelope INSIDE a 200 even
 * for application-level failures (parse_failed / upstream) — we want the
 * trainer to see the diagnostic, not a generic "request failed" toast.
 * Only auth/role/4xx errors come back through the outer `call()` wrapper.
 */
export async function runDryRun(promptKey: string, draftText: string) {
  return call<DryRunSuccessDTO | DryRunFailureDTO>(DRY_RUN_ACTION, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt_key: promptKey, draft_text: draftText }),
  });
}
